import { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import Vademecum from '../Vademecum/Vademecum'
import Diagnoses from '../Diagnoses/Diagnoses'
import useMutation from 'hooks/useMutation'
import getDate from 'lib/getDate'

function Treatment(props) {
  const [state, setState] = useState({
    consumer: { id: props.consumer?.id, label: props.consumer?.label },
    createdBy: props.user?.uid,
    createdByName: props.resource?.label || props.user?.name,
    createdByResourceID: props.resource?.id,
    date: getDate(),
    startsAt: getDate(),
    status: 'active',
    ...props.value,
    type: 'treatments'
  })
  const [mutate, mutation] = useMutation(window._l(`/records`).substr(1));
  const { t } = useTranslation()

  const onChange = ({ target: { name, value, type } }) => {
    state[name] = value
    setState({ ...state })
  }

  const onClose = () => {
    if (props.onClose) return props.onClose()
  }

  const save = () => {
    mutate(state, {
      onSuccess: record => {
        setState({ ...state, ...record })
        if (props.onSave) props.onSave(record)
      },
      // Bug real (auditoría 2026-08-14): sin onError, un guardado fallido no
      // avisaba nada — el botón volvía a "Guardar" en silencio y el
      // profesional podía creer que el tratamiento quedó guardado.
      onError: error => {
        window.notify({
          message: error.message,
          type: "danger",
          title: "Error",
        });
      },
    })
  }

  return (
    <div
      className={[props.className, 'd-flex flex-column gap-2'].filter(Boolean).join(' ')}
    >
      <div>
        <Vademecum
          value={[{
            ...state,
            key: state.product_code || state.label,
            label: state.label || [state.product, state.presentation, state.drug].filter(Boolean).join(' ')
          }].filter(s => !!(s.key && s.label))}
          onChange={array => setState({ ...state, ...array[0], id: state.id })}
        />
      </div>
      {false && 'deshabilito diagnosticos hasta no relacionarlo correctamente con el modulo en si' && (
        <div>
          <Diagnoses
            column
            value={[state.diagnostic].filter(s => !!s?.label)}
            onChange={array => setState({ ...state,  diagnostic: array[0] })}
          />
        </div>
      )}
      <div>
        <input
          type="text"
          name="dose"
          onChange={onChange}
          value={state.dose || ''}
          placeholder={t("ehr:dose", { context: 'treatments' })}
          className="form-control"
        />
      </div>
      <div>
        <input
          type="text"
          name="frecuency"
          onChange={onChange}
          value={state.frecuency || ''}
          placeholder={t("ehr:frecuency", { context: 'treatments' })}
          className="form-control"
        />
      </div>
      <div>
        <input
          type="text"
          name="notes"
          onChange={onChange}
          value={state.notes || ''}
          placeholder={t("ehr:notes", "Notas adicionales", { context: 'treatments' })}
          className="form-control"
        />
      </div>
      <div className="d-flex gap-2">
        <div className="form-floating" style={{ maxWidth: 'calc(50% - 0.25rem)' }}>
          <input
            type="date"
            name="startsAt"
            onChange={onChange}
            value={state.startsAt || ''}
            placeholder={t("ehr:startsAt", { context: 'treatments' })}
            className="form-control"
          />
          <label htmlFor="endsAt">{t("ehr:startsAt", { context: 'treatments' })}</label>
        </div>
        <div className="form-floating" style={{ maxWidth: 'calc(50% - 0.25rem)' }}>
          <input
            type="date"
            name="endsAt"
            onChange={onChange}
            value={state.endsAt || ''}
            placeholder={t("ehr:endsAt", { context: 'treatments' })}
            className="form-control"
          />
          <label htmlFor="endsAt">{t("ehr:endsAt", { context: 'treatments' })}</label>
        </div>
      </div>
      <div className="form-floating">
        <select
          name="status"
          id="status"
          onChange={onChange}
          value={state.status || ''}
          className="form-select"
        >
          <option value="active">{t("ehr:active", { context: 'treatments' })}</option>
          <option value="pending">{t("ehr:pending", { context: 'treatments' })}</option>
          <option value="done">{t("ehr:done", { context: 'treatments' })}</option>
        </select>
        <label htmlFor="status">{t("ehr:status", { context: 'treatments' })}</label>
      </div>
      <div className="d-flex justify-content-between">
        {mutation.isLoading ? (
          <button disabled className="btn btn-link mx-n2">{t('ehr:saving', { context: 'treatments' })}</button>
        ) : (
          <button disabled={!state.label} className="btn btn-link mx-n2" onClick={save}>{t('ehr:save', { context: 'treatments' })}</button>
        )}
        <button className="btn link-secondary mx-n2" onClick={onClose}>{t('close')}</button>
      </div>
    </div>
  )
}

export default Treatment
